/**
 * @flow
 * @relayHash 7c209bb56f119a364b7d1724394cfbb3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CategoryMenu_productCategories$ref = any;
export type CategoryMenuLoaderQueryVariables = {|
  langCode?: ?string,
  sellerFlag?: ?boolean,
|};
export type CategoryMenuLoaderQueryResponse = {|
  +productCategories: ?$ReadOnlyArray<?{|
    +$fragmentRefs: CategoryMenu_productCategories$ref
  |}>
|};
export type CategoryMenuLoaderQuery = {|
  variables: CategoryMenuLoaderQueryVariables,
  response: CategoryMenuLoaderQueryResponse,
|};
*/


/*
query CategoryMenuLoaderQuery(
  $langCode: String
  $sellerFlag: Boolean
) {
  productCategories(langCode: $langCode, sellerFlag: $sellerFlag) {
    ...CategoryMenu_productCategories
  }
}

fragment CategoryMenu_productCategories on ProductCategory {
  displayCategoryId
  level
  name
  itemCount
  children {
    displayCategoryId
    level
    name
    itemCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "langCode",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sellerFlag",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "langCode",
    "variableName": "langCode"
  },
  {
    "kind": "Variable",
    "name": "sellerFlag",
    "variableName": "sellerFlag"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayCategoryId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "level",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemCount",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CategoryMenuLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "productCategories",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ProductCategory",
        "plural": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CategoryMenu_productCategories",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CategoryMenuLoaderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "productCategories",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ProductCategory",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "children",
            "storageKey": null,
            "args": null,
            "concreteType": "ProductCategory",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CategoryMenuLoaderQuery",
    "id": null,
    "text": "query CategoryMenuLoaderQuery(\n  $langCode: String\n  $sellerFlag: Boolean\n) {\n  productCategories(langCode: $langCode, sellerFlag: $sellerFlag) {\n    ...CategoryMenu_productCategories\n  }\n}\n\nfragment CategoryMenu_productCategories on ProductCategory {\n  displayCategoryId\n  level\n  name\n  itemCount\n  children {\n    displayCategoryId\n    level\n    name\n    itemCount\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fa188a0d21d5949394a9e65e79171091';
module.exports = node;
